import { camelizeKeys } from "humps";
import { Stack } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";

import { SearchHighlights } from "../../../search_highlight";
import { ProfileCardProps } from "../../profile_card";
import { ProfileCardProfileInfo } from "../profile_card_profile_info";

export const ProfileCardContent = ({ profile, highlights, scrollableContainerRef }: ProfileCardProps) => (
  <Stack>
    <ProfileCardProfileInfo profile={profile} scrollableContainerRef={scrollableContainerRef} />
    {highlights && (
      <>
        <Divider />
        <SearchHighlights highlights={camelizeKeys(highlights)} />
      </>
    )}
  </Stack>
);
